/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

// Soft UI Dashboard PRO React components
import SoftBox from 'components/SoftBox';
import SoftButton from 'components/SoftButton';

// Soft UI Dashboard PRO React context
import { useSoftUIController, setLayout } from 'context';

function DashboardLayout({ children }) {
    const [controller, dispatch] = useSoftUIController();
    const { miniSidenav } = controller;
    const { pathname } = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        setLayout(dispatch, 'dashboard');
    }, [pathname]);

    // Función para manejar el botón de "Volver Atrás"
    const handleBack = () => {
        navigate(-1); // Navega hacia la página anterior
    };

    return (
        <SoftBox
            sx={({ breakpoints, transitions, functions: { pxToRem } }) => ({
                p: 3,
                position: 'relative',

                [breakpoints.up('xl')]: {
                    marginLeft: miniSidenav ? pxToRem(120) : pxToRem(274),
                    transition: transitions.create(
                        ['margin-left', 'margin-right'],
                        {
                            easing: transitions.easing.easeInOut,
                            duration: transitions.duration.standard,
                        }
                    ),
                },
            })}
        >
            {children}
        </SoftBox>
    );
}

// Typechecking props for the DashboardLayout
DashboardLayout.propTypes = {
    children: PropTypes.node.isRequired,
};

export default DashboardLayout;
